import React from 'react';
import { Group, Image as KonvaImage } from 'react-konva';
import useImage from 'use-image';
import { images as icons } from 'utils/icons';
import PropTypes from 'prop-types';

const TaskIcon = ({ x, y, icon }) => {
  //get the required icon
  const getIcon = icon => {
    if (icon.includes('https')) {
      return icon;
    } else {
      return icons[icon].default;
    }
  };
  // render the icon
  const [image] = useImage(getIcon(icon));
  const height = 20;
  const width = 20;
  return (
    <>
      <Group x={x} y={y} id={'index-key'} key={'index-key'}>
        <KonvaImage
          image={image}
          height={height}
          width={width}
          offsetX={width / 2}
          offsetY={height / 2}
        />
      </Group>
    </>
  );
};
TaskIcon.propTypes = {
  x: PropTypes.number,
  y: PropTypes.number,
  icon: PropTypes.string,
};

export default TaskIcon;
